import React, { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import SystemLogList from './list/SystemLogList';
import SystemLogSearch from './list/components/SystemLogSearch';

const SystemLogs = (props) => {

  useEffect(() => {
    window.setAppTitle('System Logs');
  }, [])

  const handleOnRowClick = (data) => {
    props.history.replace({
      pathname: `/developers/audits/system-logs/${data.id}`,
      state: {
        data: {...data}
      }
    });
  }

  return (
    <div>
      { Guardian.allows('developer.logs.system') && (
        <>
          <Row>

            <Col sm="auto" md="9" className="mb-2">
              <SystemLogSearch />
            </Col>

          </Row>

          <SystemLogList onRowClick={ handleOnRowClick }/>
        </>
      )}
    </div>
  )
}

export default SystemLogs;